import { automationProviderSelector } from "../fields/automationProviderSelector";
import { RootState } from "@/store/store";
import { defaultFilterTemplateFiltersByAccountIdSelector } from "@/store/live-usage-mgmt/thunks/filter-template/defaultFilterTemplateFiltersByAccountIdSelector";

export const allDefaultFiltersForAutomationSelector = (state: RootState) => {
  const provider = automationProviderSelector(state);

  if (!provider) {
    return;
  }

  return defaultFilterTemplateFiltersByAccountIdSelector(state, provider);
};
